import {useState,useEffect} from "react";
import React from "react";
import {useNavigate} from "react-router-dom";
import {all_routes} from "../feature-module/router/all_routes";
/* -- biz9 import start -- */
import {User} from "../project";
import {Log,Str} from "biz9-utility";
import {User_Title,User_Logic,User_Role} from "biz9-user";
import {} from "biz9-data-app";
/* -- biz9 import end -- */
const Authentication = (props) => {
    const routes = all_routes;
    const navigate = useNavigate();
    const [user,setUser] = useState(User.get());
    useEffect(() => {
        if(!Str.check_is_null(user.role)){
            if(props.role === User_Role.USER && user.role !== User_Role.USER  && user.role !== User_Role.ADMIN && user.role !== User_Role.SUPER_ADMIN){
                navigate(all_routes.home);
            }
            if(props.role === User_Role.ADMIN && user.role !== User_Role.ADMIN && user.role !== User_Role.SUPER_ADMIN){
                navigate(all_routes.home);
            }
            if(props.role === User_Role.SUPER_ADMIN && user.role !== User_Role.SUPER_ADMIN){
                navigate(all_routes.home);
            }
        }
            },[props.role,user]);
    return (
            <span></span>
           );
};
export default Authentication;
